import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter, HashRouter} from "react-router-dom";
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ProvidersAndHooks from "./providers/ProvidersAndHooks";

ReactDOM.render(
    <React.StrictMode>
        <ProvidersAndHooks>
            <HashRouter>
                <App/>
            </HashRouter>
        </ProvidersAndHooks>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
